import { Component, ViewEncapsulation } from "@angular/core";
import { StockStoreService } from "@services/stockStore.service";
import { BarcodeFormat } from "@zxing/library";
import { ZXingScannerComponent } from "@zxing/ngx-scanner";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "moveStock",
	styleUrls: ["moveStock.css"],
	templateUrl: "moveStock.html"
})
export class MoveStockComponent {
	allowedFormats = BarcodeFormat.QR_CODE;
	availableDevices: MediaDeviceInfo[] = [];
	hasCameras = false;
	hasPermission = false;
	result = "";
	scanner: ZXingScannerComponent = new ZXingScannerComponent();
	scannerEnabled = true;
	selectedDevice: any;

	constructor(private toastService: ToastService, private stockStoreService: StockStoreService) {
		this.getCameras();
	}

	cameraFound(e: any) {
		// Log to see if the camera was found
		console.log(e);
		this.availableDevices = e;
		this.selectedDevice = e[0];
		this.hasCameras = true;
		this.hasPermission = true;
		console.log("Devices: ", this.availableDevices);

		// selects the devices's back camera by default'
		for (const device of e) {
			if (/back|rear|environment/gi.test(device.label)) {
				new this.scanner.deviceChange(true);
				this.selectedDevice = device;
				break;
			} else if (e.length == 1) {
				new this.scanner.deviceChange(true);
				this.selectedDevice = device;
				break;
			}
		}
	}

	camerasNotFound() {
		// Display an alert modal here
	}

	getCameras() {
		console.log("Hit!");
	}

	onDeviceSelectChange() {
		console.log("Selection changed: ", this.selectedDevice.label);
		// this.selectedDevice = this.scanner.device!;
	}

	onScanSuccess(result: string) {
		const input = window.prompt("Enter Location", "");
		this.stockStoreService.app_PlacedItem(Guid.parse(result),input!)
			.subscribe(
				() => {
					this.toastService.success("Stock Relocated!");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}